import { Account, WorkDay, WorkSchedule, WorkScheduleExemption, WorkScheduleResource } from "@apaq/orgkit-js";
import { PageRequest } from '@apaq/leap-data-core';
import { DataSource } from "src/app/common/scheduler/datasource";
import { Resource } from "src/app/common/scheduler/resource";
import { DateEvent } from "src/app/common/scheduler/date-event";
import { RRule } from "rrule";
import { addDays, addHours, addMinutes, endOfDay, isAfter, isBefore, min, startOfDay } from "date-fns";

export class AbsenceDatasource implements DataSource {

    lastLoadedPeriod?: {from: Date, to: Date};
    
    constructor(private account: Account, private exemptions: WorkScheduleExemption[]) {
    }

    
    onResourcesChanged(callback: () => void): void {
        // TODO
    }

    onEventsChanged(callback: (dates: Date[]) => void): void {
        // TODO
    }

    async loadResources(): Promise<Resource[]> {
        return [/*{id: this.account.id, title: this.account.name}*/];
    }

    async loadDateEvents(resourceIds: string[], from: Date, to: Date): Promise<DateEvent[]> {
        this.lastLoadedPeriod = {from, to};
        return this.generateEvents(from, to);
    }

    public forceReload() {

    }

    private generateEvents(from: Date, to: Date) {
        const newEvents: DateEvent[] = [];
        
        // first generate non-recurring events
        this.applyExemptions(from, to, newEvents, this.exemptions!, ['Vacation'], false);
        this.applyExemptions(from, to, newEvents, this.exemptions!, ['DayOff'], false);
        this.applyExemptions(from, to, newEvents, this.exemptions!, ['Freelance'], false);
        this.applyExemptions(from, to, newEvents, this.exemptions!, ['AdjustedWorkDay'], false);
    
        // then generate recurring events
        this.applyExemptions(from, to, newEvents, this.exemptions!, ['Vacation'], true);
        this.applyExemptions(from, to, newEvents, this.exemptions!, ['DayOff'], true);
        this.applyExemptions(from, to, newEvents, this.exemptions!, ['Freelance'], true);
        this.applyExemptions(from, to, newEvents, this.exemptions!, ['AdjustedWorkDay'], true);
    
        return newEvents;
      }

      private applyExemptions(start: Date, end: Date, events: any[], exemptions: WorkScheduleExemption[], types: string[],
        recurring: boolean) {
        exemptions.forEach((exemption: WorkScheduleExemption, index: number) => {
          const hasReccurence = exemption.recurrenceRule != null;
          if (types.indexOf(exemption.type) >= 0 && hasReccurence === recurring) {
            const tempEvents = this.generateEventsFromExemption(start, end, exemption, index);
            tempEvents.forEach((event) => {
              events.push(event);
            });
          }
        });
      }

      private generateEventsFromExemption(start: Date, end: Date, exemption: WorkScheduleExemption, index: number) {
        let dates: Date[];
        const events = [];

        let type = 'info';
        if(exemption.type === 'AdjustedWorkDay') {
          type = 'primary'
        }

        if(exemption.type === 'DayOff') {
          type = 'success'
        }

        if (exemption.recurrenceRule) {
          const options = RRule.parseString(exemption.recurrenceRule);
      
          // We do not currently use time of day. Ensure exemption start date is in the morning(instead of midnight) so it
          // does no risk being ignored on the first day of month  during summer time.
          options.dtstart = addHours(startOfDay(exemption.startDate), 6);
          const rule = new RRule(options);
          dates = rule.between(start, end);
          dates.forEach(date => {
            const workDay: WorkDay = exemption.workDay;
            const workDayStart = workDay ? addMinutes(addHours(date, workDay.startTime.getHours()), workDay.startTime.getMinutes()) : startOfDay(date);
            const workDayEnd = workDay ? addMinutes(addHours(date, workDay.endTime.getHours()), workDay.endTime.getMinutes()) : startOfDay(date);
    
            const newEvent = {
              id: 'exemption-' + index,
              title: exemption.description ?? exemption.type,
              type,
              start: startOfDay(workDayStart),
              end: endOfDay(workDayEnd),
              shape: "Background",
              exemption
            } as DateEvent;
            events.push(newEvent);
          });
        } else {
          const exemptionStart = exemption.startDate;
          const exemptionEnd = exemption.endDate != null ? min([end, exemption.endDate]) : exemptionStart;
    
          if (isBefore(start, exemptionEnd) && isAfter(end, exemptionStart)) {
            let date = exemptionStart;
            while(!isAfter(date, endOfDay(exemptionEnd))) {
              const newEvent = {
                id: 'exemption-' + index,
                title: exemption.description ?? exemption.type,
                type,
                start: startOfDay(date),
                end: endOfDay(date),
                shape: "Background",
                exemption
              } as DateEvent;
              events.push(newEvent);
              date = addDays(date, 1);
            }
            
          }
        }
        return events;
      }

}